// extracted by mini-css-extract-plugin
module.exports = {"container":"indicators_container__Vgq0B","col":"indicators_col__3XcWF","title":"indicators_title__1xLxg","subtitle":"indicators_subtitle__C957K"};